import { render, staticRenderFns } from "./PaddlingWithRanger.vue?vue&type=template&id=2e61fa92&scoped=true&"
import script from "./PaddlingWithRanger.vue?vue&type=script&lang=js&"
export * from "./PaddlingWithRanger.vue?vue&type=script&lang=js&"
import style0 from "./PaddlingWithRanger.vue?vue&type=style&index=0&id=2e61fa92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61fa92",
  null
  
)

export default component.exports